<div id="device-detail-wrapper" data-cy="device-detail-wrapper">
  <p *ngIf="notFound" data-cy="device-not-found">Device not found.</p>

  <ep-device-form-card
    *ngIf="device && !notFound"
    [mode]="(mode$ | async)!"
    [isSaving]="isSaving"
    [isSaveDisabled]="(isSaveDisabled$ | async) === true"
    [statusValue]="deviceStatusLabel(device)"
    [statusSeverity]="deviceStatusSeverity(device)"
    (edit)="edit()"
    (cancel)="cancelEdit()"
    (save)="saveDevice()"
  >
    <app-device-form></app-device-form>
  </ep-device-form-card>
</div>
